import React from "react";
import AdpEventForm from "./AdpEventForm";

export default function UpneticTab() {
    return (
        <div style={{ padding: 24 }}>
            <AdpEventForm/>
        </div>
    )
}